<template>
  <b-modal v-model="modal" id="distribuidor-modal-create" size="lg" hide-footer>
    <template v-slot:modal-header="{ close }">
      <h4>{{title}}</h4>
      <i class="fas fa-times modal-close-icon" @click="close()"></i>
    </template>
    <b-overlay :show="false" rounded="sm">
      <Form v-model.trim="distribuidorForm" :config="distribuidorFromConfig" @submit="onSubmit()">
        <template slot="titleText" slot-scope="props">
          <h4 v-if="props.fieldTitleText" class="title ml-2 m-0">{{ props.fieldTitleText }}</h4>
        </template>
        <template slot="button-text">{{isEdit === true ? 'Editar': 'Crear'}}</template>
      </Form>
    </b-overlay>
  </b-modal>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Form from "@/components/form";
export default {
  components: {
    Form
  },
  props: {
    distribuidor: {
      type: Object,
      default: null
    },
    type: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      modal: false,
      data: [],
      distribuidorForm: {},
      distribuidorFromConfig: {
        fields: [
          {
            label: "Nombre del distribuidor*",
            name: "nombreDis",
            text: "Nombre de la empresa",
            type: "text",
            rules: {
              required: true
            },
            cols: 6
          },
          {
            label: "Dirección del distribuidor*",
            name: "direccionDis",
            text: "dirección de la distribuidor",
            type: "text",
            rules: {
              required: true
            },
            cols: 6
          },
          {
            label: "Telefono 1*",
            name: "tel1",
            text: "telefono 1",
            type: "text",
            rules: {
              required: true
            },
            cols: "4"
          },
          {
            label: "Telefono 2",
            name: "tel2",
            text: "telefono 2",
            type: "text",
            cols: "4"
          },
          {
            label: "Telefono 3",
            name: "tel3",
            text: "telefono 3",
            type: "text",
            cols: "4"
          },
          {
            label: "E-mail*",
            name: "email",
            text: "E-mail",
            type: "email",
            rules: {
              required: true,
              email: true
            },
            cols: "6"
          },
          {
            label: "Sitio web",
            name: "web",
            text: "sitio web",
            type: "text",
            cols: "6"
          },
          {
            label: "Estatus*",
            name: "status",
            text: "Estatus",
            type: "select",
            options: [
              { value: 1, text: "Activo" },
              { value: 0, text: "Inactivo" }
            ],
            rules: {
              required: true
            },
            cols: "6"
          },
          {
            label: "Estado*",
            name: "state",
            text: "Estado",
            type: "select",
            options: this.data,
            rules: {
              required: true
            },
            cols: "6"
          }
        ],
        floatingLabels: true,
        autocomplete: false,
        submitText: "Crear",
        submitClasses: "main-btn  text-uppercase mt-3"
      }
    };
  },
  computed: {
    ...mapState("distribuidores", ["estados", "createStatus", "updateStatus"]),
    title() {
      return this.type === "create"
        ? "Nuevo distribuidor"
        : "Editar distribuidor";
    },
    isEdit() {
      return this.type === "edit";
    }
  },
  watch: {
    estados() {
      this.distribuidorFromConfig.fields.forEach(item => {
        if (item.name === "state") item.options = this.estados;
      });
    },
    createStatus(value) {
      if (value === "success") {
        this.$bvModal.hide("distribuidor-modal-create");
      }
    },
    updateStatus(value) {
      if (value === "success") {
        this.$bvModal.hide("distribuidor-modal-create");
      }
    },
    modal(val) {
      this.distribuidorForm = {};
      if (val && this.isEdit) {
        const temp = {
          idDistribuidor: this.distribuidor.idDistribuidor,
          tel1: this.distribuidor.Tel1,
          tel2: this.distribuidor.Tel2,
          tel3: this.distribuidor.Tel3,
          status: this.distribuidor.activo,
          direccionDis: this.distribuidor.direccionDistribuidor,
          email: this.distribuidor.email,
          state: Number(this.distribuidor.idEstado),
          nombreDis: this.distribuidor.nombreDistribuidor,
          web: this.distribuidor.web
        };
        this.distribuidorForm = temp;
      }
    }
  },
  methods: {
    ...mapActions("distribuidores", [
      "createDistribuidor",
      "updateDistribuidor"
    ]),
    onSubmit() {
      if (this.isEdit) {
        this.updateDistribuidor(this.distribuidorForm);
      } else {
        this.createDistribuidor(this.distribuidorForm);
      }
    }
  }
};
</script>
